export enum ProductType {
  Checking = "DDA",
  Savings = "SAV",
  MoneyMarket = "MMA",
  Time = "COD"
}
